import { useState } from "react";
import { X } from "lucide-react";

// Comma/Enter-separated tag input for skills / technologies (stored as string[]).
export default function TagInput({ value = [], onChange, placeholder = "Type and press Enter", testid = "tags" }) {
  const [draft, setDraft] = useState("");
  const add = (raw) => {
    const parts = raw.split(",").map((s) => s.trim()).filter(Boolean);
    if (!parts.length) return;
    const next = [...value];
    parts.forEach((p) => { if (!next.includes(p)) next.push(p); });
    onChange(next); setDraft("");
  };
  const remove = (i) => onChange(value.filter((_, idx) => idx !== i));
  return (
    <div data-testid={testid} className="flex flex-wrap items-center gap-1.5 rounded-md border border-white/10 bg-black/30 p-1.5">
      {value.map((t, i) => (
        <span key={i} data-testid={`${testid}-chip-${i}`} className="inline-flex items-center gap-1 rounded-full bg-emerald-400/15 px-2 py-0.5 text-[12px] font-medium text-emerald-200">
          {t}
          <button onClick={() => remove(i)} className="text-emerald-200/70 hover:text-white" data-testid={`${testid}-remove-${i}`}><X size={11} /></button>
        </span>
      ))}
      <input
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(draft); } else if (e.key === "Backspace" && !draft && value.length) { remove(value.length - 1); } }}
        onBlur={() => draft && add(draft)}
        placeholder={placeholder}
        data-testid={`${testid}-input`}
        className="min-w-[120px] flex-1 bg-transparent px-1 py-0.5 text-[13px] text-white outline-none placeholder:text-white/30"
      />
    </div>
  );
}
